export default {
    title: 'Tags',
    'create-button': 'Create Tag',
    'add-tag': 'Add tag',
    'remove-dialog': {
        title: 'Remove tag?',
        description: 'Are you sure you want to remove tag: {tag}',
    },
    fields: {
        category: 'Category',
        name: 'Name',
        value: 'Value',
        description: 'Description',
        priority: 'Priority',
    },
    search: 'Search by name or value',

    category: {
        title: 'Tag categories',
        'create-button': 'Create Category',
        'remove-dialog': {
            title: 'Remove category?',
            description: 'Are you sure you want to remove category: {category}',
        },
        fields: {
            name: 'Name',
            description: 'Description',
        },
        search: 'Search by name or description',
    },
}
